import { render, staticRenderFns } from "./elasticFilters.vue?vue&type=template&id=a93635e4"
import script from "./elasticFilters.vue?vue&type=script&lang=js"
export * from "./elasticFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Check: require('/home/ubuntu/containers/hermes_eshop/components/core/check.vue').default})
